import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

const FormErrorMessageStyle = () => css`
  color: ${Colors.errorMsg};
`;

const FormErrorMessage = styled.span`
  ${FormErrorMessageStyle}
  ${mq({
    display: ['block', 'initial'],
    marginTop: ['10px', '0px'],
  })};
`;

export default FormErrorMessage;
